define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/when",
	"csi/html",
	"csi/locale",
	"csi/store/_base",
	"csi/toolbar/_SelectSwitchboard",
	"csi/widget/FilteringSelect"
], function(declare, lang, when, html, locale, csiStore, _SelectSwitchboard, FilteringSelect) {

	// TODO: move to csi/toolbar/SingleSelectSwitchboard?

	return declare(_SelectSwitchboard, {
		selectClass: FilteringSelect,

		// Boolean: indicates if this switchboard supports ExcelSwitchboard action, which basically means if the switchboard
		// solely changes the view's root node rather than controlling some other logic (must be explicitly enabled)
		//bSupportsExcel: false,

		// String: resource to use to populate empty item in switchboard (if placeholder specified, then probably set to "")
		//resDefault: null,

		onChangeItem: function(/*csi.view.Widget*/view, /*Node*/node) {
			// summary: by default, switchboard plugin will reset view root node
			view.setViewNode(node);
		},

		onChangeValue: function(/*csi.view.Widget*/view, /*String?*/value) {
			// summary: react to value change
			this.onChangeItem(view, view.cacheView.getNode(value, true));
		},

		_getStoreOptions: function(/*String*/url, /*Relationship?*/r) {
			// summary: add default option
			var options = this.inherited(arguments);

			if (this.resDefault != null) {
				options.data = options.data || [];
				options.data.unshift(csiStore.nameObject(locale.resource(this.resDefault)));
			}

			return options;
		},

		_onDefaultValue: function(/*String?*/preferredValue, /*String?*/defaultValue) {
			// summary: if value is given and still exists in store, then use it; otherwise set to default value
			if (!html.exists(this)) {
				this._resolveDeferred();
				return;
			}

			var valueOld = this.selectNode.get("value") || "";
			var value;

			if (!defaultValue) {
				// nothing in store if no default value
				this.selectNode.set("disabled", true);
				this._bEmptyStore = true;
			} else if (!preferredValue || !this.store.get(preferredValue)) {
				value = defaultValue;
			} else {
				value = preferredValue;
			}

			value = value || "";

			if (value != valueOld) {
				this._setSelectNodeValue(value);
				return;
			}

			// force onChange if no items in store for first query
			if (!value) {
				this._setSwitchboardValue(value);
			}

			this._resolveDeferred();
		},

		_setValueAttr: function(/*String?*/value) {
			// summary: set value on select node - if none given, then select default value
			if (this.store?.getDefaultValue) {
				when(this.store.getDefaultValue(null, true), lang.hitch(this, this._onDefaultValue, value));
			} else {
				this.inherited(arguments);
			}
		}
	});
});